import { InvoiceFormProduct } from '../Constants/invoiceFormikData';

export interface ListPriceUpdate {
  productId: string;
  averagePricePerUnit: number;
  averagePricePerUnitUnit: string;
  packageWeight?: number;
}

/**
 * Turns the invoice's line items into the body for the inventory prices
 * endpoint, keeping only the lines whose price the user asked to promote.
 *
 * Omits the product density the Applications flow sends, since neither service
 * defines that property here. Package weight is echoed back only when the
 * product has one: the endpoint assigns that column unconditionally, so an
 * absent value would write NULL over whatever was stored.
 *
 * A product on several lines yields one entry, last line winning, matching how
 * both services fold repeated ids onto a single record.
 */
const buildListPriceUpdates = (
  invoiceProducts: InvoiceFormProduct[] = []
): ListPriceUpdate[] => {
  const byProductId = new Map<string, ListPriceUpdate>();

  invoiceProducts.forEach(product => {
    const { productId, priceValue, priceUnit, saveAsNewListPrice } = product;

    if (!saveAsNewListPrice || !productId) return;
    if (!Number.isFinite(priceValue) || !priceValue || priceValue <= 0) return;

    const update: ListPriceUpdate = {
      productId,
      averagePricePerUnit: priceValue,
      averagePricePerUnitUnit: priceUnit ?? ''
    };
    if (Number.isFinite(product.packageWeight)) {
      update.packageWeight = product.packageWeight;
    }
    byProductId.set(productId, update);
  });

  return [...byProductId.values()];
};

export default buildListPriceUpdates;
